var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",style:([_vm.size ? { '--spinner-size': _vm.size } : null])},[_c('div',{staticClass:"loading-overlay-inner"},[_c('LoadingAnimation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }